import styled from 'styled-components';

export const Content = styled.div`
  flex: 1;
  overflow: auto;
`;
